// eslint-disable-next-line import/no-anonymous-default-export
export default {

  SECTION_a: "General Information",
  SECTION_b: "Quality & Quantity Assessment of Served Food",
  SECTION_c: "Water Safety",
  SECTION_d: "General cleanliness of distribution area",
  SECTION_e: "Safety Arrangements",
  SECTION_f: "Sanitation",
  SECTION_g: "Waste Management",
  SECTION_h: "Hygiene",
  SECTION_i: "Food Hygiene",
  SECTION_j: "IEC & Monitoring",
  SECTION_k: "Challenges & Suggestions",

  

  // Section A — General Information
  A1: "Whether kiosk remains functional everyday including on holidays. If NO, specify the reason in the remark coloumn for non functioning everyday.",
  A1_HELPER: "Upload the supporting orders from ULB",
  A2: "Whether kiosk is operated by SHGs or others. If others, specify in the remark coloumn, who are operating and the reason for non-engagement of SHGs.",
  A3: "Mention the number of staff engaged in the functioning of kiosk",
  A4: "Timing for service of meal (Guideline Stated Timing from 12 NOON to 3 PM)",
  A5: "Average Number of beneficiaries benefitted per DAY",
  A6: "Whether receipt of Food Coupons preserved at ULB level for future reference and Audit purpose",

  // Section B — Quality & Quantity Assessment of Served Food
  B1: "How would you rate the quality of the meal served?",
  B2: "How would you rate the quantity of meal served",
  B3: "Are all specified items ( ie. Rice, Dal, Sabji and One full Tabled egg) being served everyday",

  // Section C — Water Safety
  C1: "Is there a provision for safe and potable drinking water for beneficiaries at the kiosk?",
  C2: "If YES, mention what arrangement made for proving safe drinking water to the beneficiaries?",
  C2_HELPER: "Upload the picture of the drinking water point",
  C3: "Is the drinking water being tested for chemical and bacteriological parameters in every six months, with records maintained?",
  C3_HELPER: "If Yes, Please mention the last date of the water quality testing and upload the corresponding test report.",

  // Section D — General cleanliness of distribution area
  "D.1": "Does the kiosk have adequate space for food distribution?",
  "D.2": "Does the kiosk maintains hygiene while handling and distributing food to the beneficiaries? Tick the applicable option. If all hygiene conditions are not met, please specify the gaps in the remarks column.",
  "D.3": "Is the distribution area being cleaned and sanitised daily before and after distribution of food at kiosk and whether the process is recorded in housekeepig checklist? If the cleaning process is daily recorded in housekeeping checklist, assign YES.",
  "D.3_HELPER": "Upload the latest housekeeping record for verification.",
  "D.4": "How would you rate the overall cleanliness of the kiosk",

  // Section E — Safety Arrangements
  "E.1": "Is an overhead shed available at the kiosk to provide protection to the beneficiaries from excessive heat and rainfall?",
  "E.2": "Is the kiosk situated at a location that is free from water stagnation and not prone to flooding?",

  // Section F — Sanitation
  "F.1": "Is there a dedicated functional toilet for canteen staff near kiosk? (*Functionality of toilet means availability of running water for flushing and cleaning, non-choking toilet pans and urinals, functional cisterns, washbasin with soap and water for handwash and proper drainage system).",
  "F.2": "Are the toilets well ventilated, illuminated and maintain privacy?",
  "F.3": "Are the toilets cleaned everyday and recorded in housekeeping checklist? (Check the housekeeping checklist and if updated daily, assign YES)",
  "F.4": "Is there a covered dustbin in staff's toilet for disposal of sanitary waste?",
  "F.4_HELPER": "Upload the current month's housekeeping record for verification",

  // Section G — Waste Management
  "G.1": "Are there coloured bins (green and blue) for waste segregation (bio and non-biodegradable waste) near kiosk",
  "G.2": "Whether IEC on waste segregation is displayed near the waste bins?",
  "G.2_HELPER": "Upload the picture for verification",
  "G.3": "Waste bins cleaned everyday after emptying the waste and recorded in housekeeping checklist. (Check the housekeeping checklist, if record is up to date, assign YES)",
  "G.3_HELPER": "Upload the housekeeping checklist record for verification",
  "G.4": "Is single-use plastic being used in the kiosk?",

  // Section H — Hygiene
  "H.1": "Do the staff wear appropriate protective gear in kiosk while distributing food and cleaning? i. apron, cap, mask and food handling gloves during serving food ii. apron and utility gloves while cleaning the kiosk and its surroundings.",
  "H.1_HELPER": "Upload the picture of staff wearing PPE while doing activities",
  "H.2": "Is there a functional handwashing station near the food distribution point for staff and beneficiaries? (* Functional handwashing station must have a handwashing area with running water, soap for handwash, unbroken and no leakage taps, outlet pipe connected to a proper drainage system). (If all the above conditions are available, respond YES)",
  "H.2_HELPER": "Upload the picture of the handwashing station near kiosk area",
  "H.3": "Is there a water stagnation in the surrounding area of handwashing station or drain?",
  "H.4": "Are the staff aware and practice 6 steps of handwashing before serving food and after cleaning the kiosk? (Observe the moments of hand washing - 1. before serving food 2. after using toilet and 3. After cleaning the kiosk)",
  "H.5": "Are half-yearly health check-ups conducted for the staff, and are the records properly maintained? (Half yearly health check-ups for staff and maintain record)",
  "H.5_HELPER": "Upload the last updated record for verification",
  "H.6": "Do the staff maintain personal hygiene (no nail polish, trimmed nails, covered hair, etc.)",

  // Section I — Food Hygiene
  "I.1": "What type of plates are used for serving food to the beneficiaries? If other material or NA, please specify in the remark coloumn what material plates are used or how the food is distributed.",

  // Section J — IEC & Monitoring
  "J.1": "Are the posters on handwashing, safe toilet use, etc. displayed in the canteen?",
  "J.2": "Whether regular Online Entry being done in Online Portal?",
  "J.3": "Whether Daily entry being reconciled with Number of Coupon distributed?",

  // Section K — Challenges & Suggestion
  "1": "Challenges (If Any)",
  "2": "Sugesstions (If Any)",
};